import React from 'react';

const LEVEL_COLORS = {
  NOMINAL: '#818CF8',
  ELEVATED: '#F59E0B',
  DISRUPTIVE: '#F97316',
  CRITICAL: '#EF4444',
};

const DOMAIN_LABELS = {
  airport_operations: 'AVIATION',
  port_operations: 'MARITIME',
  road_transport: 'ROAD',
  utilities: 'UTILITIES',
  telecommunications: 'TELECOM',
  logistics_supply_chain: 'LOGISTICS',
  emergency_systems: 'EMERGENCY',
  public_safety: 'PUBLIC',
};

export default function VegaLeftPanel({ state, scoring, connectors }) {
  const levelColor = LEVEL_COLORS[state?.level] || '#818CF8';
  const confidence = scoring?.finalConfidenceScore || 0;
  const domainCov = state?.domain_coverage || {};

  return (
    <div className="vega-left" data-testid="vega-left-panel">
      {/* Avatar */}
      <div className="vega-avatar-wrap">
        <div className="vega-avatar-outer">
          <div className="vega-orbit" style={{ borderColor: '#6366F120' }}>
            <div className="vega-orbit-dot" style={{ background: '#6366F1', boxShadow: '0 0 6px #6366F1' }} />
          </div>
          <div className="vega-avatar-core">
            <svg className="vega-avatar-svg" viewBox="0 0 40 40" data-testid="vega-avatar">
              <polygon points="20,4 36,32 4,32" fill="none" stroke="#6366F1" strokeWidth="1.5" opacity="0.6" />
              <polygon points="20,10 30,28 10,28" fill="none" stroke="#8B5CF6" strokeWidth="1" opacity="0.4" />
              <circle cx="20" cy="22" r="3" fill="#6366F1" opacity="0.8" />
              <line x1="20" y1="14" x2="20" y2="19" stroke="#C4B5FD" strokeWidth="0.5" />
            </svg>
          </div>
        </div>
        <div className="vega-avatar-name" data-testid="vega-agent-name">VEGA</div>
        <div className="vega-avatar-state" style={{ color: levelColor }} data-testid="vega-state-level">
          {state?.level || 'NOMINAL'}
        </div>
      </div>

      {/* Confidence */}
      <div className="vega-conf" data-testid="vega-confidence-section">
        <div className="vega-conf-row">
          <span className="vega-conf-label">CONFIDENCE</span>
          <span className="vega-conf-val" style={{ color: levelColor }}>{Math.round(confidence)}%</span>
        </div>
        <div className="vega-bar-track">
          <div className="vega-bar-fill" style={{ width: `${confidence}%`, background: `linear-gradient(90deg, #6366F1, #8B5CF6)` }} />
        </div>
      </div>

      {/* Severity */}
      <div className="vega-conf" data-testid="vega-severity-section">
        <div className="vega-conf-row">
          <span className="vega-conf-label">SEVERITY</span>
          <span className="vega-conf-val" style={{ color: levelColor }}>{scoring?.severity || 'nominal'}</span>
        </div>
      </div>

      {/* Domain Coverage */}
      <div className="vega-section" data-testid="vega-domain-coverage">
        <div className="vega-section-label">DOMAIN COVERAGE</div>
        {Object.entries(DOMAIN_LABELS).map(([key, label]) => {
          const count = domainCov[key] || 0;
          const active = count > 0;
          return (
            <div className="vega-domain-row" key={key}>
              <div className={`vega-domain-dot ${active ? 'active' : ''}`} />
              <div className="vega-domain-name">{label}</div>
              <div className="vega-domain-count" style={{ color: active ? '#6366F1' : '#5A5A8A' }}>{count}</div>
            </div>
          );
        })}
      </div>

      {/* Active Focus */}
      {state?.active_focus?.length > 0 && (
        <div className="vega-section" data-testid="vega-active-focus">
          <div className="vega-section-label">ACTIVE FOCUS</div>
          {state.active_focus.slice(0, 4).map((f, i) => (
            <div className="vega-focus-row" key={i}>
              <span className="vega-focus-cat">{f.category}</span>
              <span className="vega-focus-detail">{f.detail}</span>
            </div>
          ))}
        </div>
      )}

      {/* Connector Health */}
      <div className="vega-section" data-testid="vega-connector-health">
        <div className="vega-section-label">CONNECTORS</div>
        {Object.entries(connectors || {}).map(([name, info]) => (
          <div className="vega-source-row" key={name}>
            <div className="vega-source-dot" style={{ background: info.status === 'ok' ? '#22C55E' : '#EF4444' }} />
            <div className="vega-source-name">{name}</div>
            <div className="vega-source-count">{info.signals || 0}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
